import { render, staticRenderFns } from "./KategoriPromoSetup.vue?vue&type=template&id=d1ea3802"
import script from "./KategoriPromoSetup.vue?vue&type=script&lang=js"
export * from "./KategoriPromoSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports